import React from 'react';
import Tr from './styles';

export default ({ children, ...otherProps }) => <Tr {...otherProps}>{children}</Tr>;;
